import React from 'react';
import { connect } from 'react-redux';

import { APOLLO_COMMUNITY } from 'ha/constants/pageNames';
import { withHermes, getLinkData, HermesProps } from 'ha/modules/Hermes';
import { GlobalState } from 'ha/types/store';

import { LinkData } from 'ha/modules/Hermes/types';
import Page from 'ha/modules/Page';
import CommunityPageLayout from '../components/CommunityPageLayout';
import { HermesData } from '../types';

const mapStateToProps = (state: GlobalState) => ({
  linkData: getLinkData(state),
});

interface Props {
  linkData: LinkData[];
}

export const CommunityPage: React.FC<
  Props & HermesProps<HermesData>
> = props => {
  const countryCode = props.data.country?.canonical;

  return (
    <Page
      name={APOLLO_COMMUNITY}
      category={APOLLO_COMMUNITY}
      hasFooter={false}
      hideIntercom
      traits={{ countryCode }}
    >
      <CommunityPageLayout {...props} />
    </Page>
  );
};

export default withHermes(connect(mapStateToProps)(CommunityPage));
